import InvoicesTableComponent from './components/invoices/invoices-table';
import TotalAmountComponent from './components/total-amount';
import NewRecordsInvoicesComponent from './components/new-records-invoices';

import './styles/invoices.scss';

export const InvoicesTable = InvoicesTableComponent;
export const TotalAmount = TotalAmountComponent;
export const NewRecordsInvoices = NewRecordsInvoicesComponent;
